import React, {useEffect} from 'react'
import './PageRow.css'

function PageRow({ children, className }) {
    useEffect(() => {
        const anchoVentana = window.innerWidth
        const contenido = document.querySelector('.pageRow')

        if (contenido) {
            const anchoContenido = contenido.offsetWidth
            const anchoMargen = (anchoVentana - anchoContenido) / 2
            const anchoMenu = anchoVentana - anchoMargen

            document.querySelector('.navbar-wrapper').style.width = `${anchoMenu}px`
        }

    }, [])

    return <div className={`pageRow ${className}`}>{children}</div>
}

export default PageRow
